import React from 'react'
import './styles.css'
interface ButtonProps {
    label: string,
    variant: 'contained' | 'outlined' | 'delete',
    onClick(): any,
    disabled?: boolean,
    id?: string
}

export default function Button(props: ButtonProps): JSX.Element {

    return (
        <button
            id={props.id || "button"}
            aria-disabled={props.disabled}
            className={`button ${props.variant} ${props.disabled && 'disabled'}`}
            onClick={() => !props.disabled && props.onClick()}
        >
            <p>{props.label}</p>
        </button>
    )
}